<template>
  <div>
    <form v-on:submit.prevent="saveChanges">
      <div class="form-group">
        <label for="exampleFormControlSelect1"
          >View available options for units</label
        >
        <select class="form-control" id="exampleFormControlSelect1">
          <option v-for="o in getOptions.units" :key="o.index">{{ o }}</option>
        </select>

        <label for="units">Dodaj novu jedinicu za kolicinu</label>
        <input
          id="units"
          type="text"
          class="form-control"
          placeholder="Dodaj novu jedinicu"
          v-model="units"
        />
      </div>
      <div class="form-group">
        <label for="workTime">View available options for work time</label>
        <select class="form-control" id="workTime">
          <option v-for="o in getOptions.workTime" :key="o.index">{{
            o
          }}</option>
        </select>

        <label for="exampleFormControlInput1"
          >Dodaj novu opciju za radno vrijeme</label
        >
        <input
          type="text"
          class="form-control"
          placeholder="Dodaj novu opciju za radno vrijeme"
          v-model="workTime"
        />
      </div>
      <div class="form-group">
        <label for="exampleFormControlSelect1"
          >View available options for selecting worklogs issue type</label
        >
        <select class="form-control" id="exampleFormControlSelect1">
          <option v-for="o in getOptions.knownProblems" :key="o.index">{{
            o
          }}</option>
        </select>

        <label for="exampleFormControlInput1"
          >Dodaj novu opciju za tip problema</label
        >
        <input
          type="text"
          class="form-control"
          placeholder="Dodaj novu opciju za tip problema"
          v-model="typeOfProblem"
        />
      </div>
      <div class="form-group">
        <label for="exampleFormControlSelect1"
          >View available options for selecting worklogs location</label
        >
        <select class="form-control" id="exampleFormControlSelect1">
          <option v-for="o in getOptions.location" :key="o.index">{{
            o
          }}</option>
        </select>

        <label for="exampleFormControlInput1"
          >Dodaj novu opciju za lokaciju</label
        >
        <input
          type="text"
          class="form-control"
          placeholder="Dodaj novu opciju za lokaciju"
          v-model="location"
        />
      </div>
      <button type="submit" class="btn btn-primary">
        Sacuvaj izmjene
      </button>
    </form>
  </div>
</template>
<script>
export default {
  data() {
    return {
      units: "",
      workTime: "",
      typeOfProblem: "",
      location: ""
    };
  },
  computed: {
    getOptions() {
      return this.$store.getters.getOptions;
    }
  },
  methods: {
    saveChanges() {
      const updatedOptions = {
        units: this.units,
        workTime: this.workTime,
        typeOfProblem: this.typeOfProblem,
        location: this.location,
        prevOpt: this.getOptions
      };
      this.$store.dispatch("updatedAllOptions", updatedOptions);
    }
  }
};
</script>
<style></style>
